import React from "react";
import AnalysisDetailPageForDecisionManager from "./AnalysisDetailPageForDecisionManager";
import AnalysisDetailPageForRegularMember from "./AnalysisDetailPageForRegularMember";
import { useParams } from "react-router-dom";
import useDocumentDetailRedirect from "features/document/hooks/read/useDocumentDetailRedirect";

const DocumentAnalysisDetailPage = () => {
  const documentUuid = useParams().uuid as string;

  const { accessType } = useDocumentDetailRedirect({ documentUuid });

  if (accessType === "APPROVABLE") {
    return <AnalysisDetailPageForDecisionManager />;
  } else if (accessType === "READ_ONLY") {
    return <AnalysisDetailPageForRegularMember />;
  } else {
    return null;
  }
};

export default DocumentAnalysisDetailPage;
